module.exports = __webpack_public_path__ + "static/media/admin_black.0c91d91f.svg";